import { find, get } from 'lodash';
import selectGameKeys from './select-game-keys';
import { selectTotalScoreNumber } from './best-score';

const selectGamePath = (challenges, gameKey, challengeKey) => get(find(challenges, { application: gameKey, challenge_key: challengeKey }), 'path', null);

const selectGameSummary = (game, phrases) => {
  if (!game) return null;

  const { summary } = phrases;
  const totalScore = selectTotalScoreNumber([game], 'score');

  return [
    {
      key: 'average_score',
      value: `$${game.rank}`,
      descriptor: summary.averageScore,
    },
    {
      key: 'answers',
      value: `${totalScore < 0 ? '-' : ''}$${Math.abs(totalScore)}`,
      units: phrases.scoreUnitsDollars,
      descriptor: summary.scored,
    },
  ];
};

const selectScoreCardHotRisk = (game, phrases, remainingChallenges, gameKeys, challengeKey) => {
  const {
    gameTitle, gameDescription, unplayedGameDescription, playNow,
  } = phrases;
  const summary = selectGameSummary(game, phrases);

  return {
    heroKey: gameKeys.key,
    gameTitle,
    gameDescription: summary ? gameDescription : unplayedGameDescription,
    summary: selectGameSummary(game, phrases),
    nextGamePath: !summary ? selectGamePath(remainingChallenges, 'hot_risk', challengeKey) : null,
    nextGameLink: playNow,
    ...gameKeys,
  };
};

export const selectScoreCardHotRiskPositive = ({ hotRisk } = {}, phrases, remainingChallenges) => {
  const positiveGame = hotRisk?.games[0];
  return selectScoreCardHotRisk(
    positiveGame,
    { summary: phrases.summary, ...phrases.hotRisk, ...phrases.hotRiskPositive },
    remainingChallenges,
    selectGameKeys({ hotRisk }, 'positive'),
    'game_number_1',
  );
};

export const selectScoreCardHotRiskNegative = ({ hotRisk } = {}, phrases, remainingChallenges) => {
  const negativeGame = hotRisk?.games[1];
  return selectScoreCardHotRisk(
    negativeGame,
    { summary: phrases.summary, ...phrases.hotRisk, ...phrases.hotRiskNegative },
    remainingChallenges,
    selectGameKeys({ hotRisk }, 'negative'),
    'game_number_2',
  );
};
